<template>
    <div class="digital-certificate-qr" data-certificate-qr>
        <div class="digital-certificate-qr__code">
            <vue-qr
                :text="url"
                :size="320"
                :margin="0"
                :correctLevel="1"
                :colorDark="colorDark"
                colorLight="#FFFFFF"
            />
        </div>
        <div class="digital-certificate-qr__label">Digitally certified</div>
    </div>
</template>

<script>
import VueQr from 'vue-qr'

export default {
    name: 'DigitalCertificateQr',
    components: {
        VueQr
    },
    props: {
        url: {
            type: String,
            required: true
        },
        colorDark: {
            type: String,
            default: '#E90046'
        }
    }
}
</script>

<style lang="scss" scoped>
.digital-certificate-qr {
    width: 140px;
    text-align: center;
    color: #333;

    &__code {
        display: inline-flex;
        padding: 5px;
        background: #fff;
    }

    &__code ::v-deep img {
        display: block;
        width: 92px;
        height: 92px;
        image-rendering: pixelated;
        image-rendering: crisp-edges;
    }

    &__label {
        margin-top: 2px;
        font-size: 9px;
        line-height: 12px;
        font-weight: 700;
        letter-spacing: 0.8px;
        text-transform: uppercase;
    }
}
</style>
